import { render, staticRenderFns } from "./zitat-block-field.vue?vue&type=template&id=dfb2a880"
import script from "./zitat-block-field.vue?vue&type=script&lang=js"
export * from "./zitat-block-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports